// FNP-2137: admin group only. Inbound mail to a DISABLED alias goes to alias.not.found.
export const adminSetAliasStatus = `
  mutation adminSetAliasStatus($input: AdminSetAliasStatusInput!) {
    adminSetAliasStatus(input: $input) {
      id
      name
      aliasType
      aliasStatus
      updated
      updatedByUsername
    }
  }
`;
